import { IAppState } from '../../redux';
import { selectActiveService } from './selectActiveService';

export function selectActivePackageId(state: IAppState): string | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { selectedPackageId },
  } = selectedService;

  return selectedPackageId;
}
